// extracted by mini-css-extract-plugin
module.exports = {"topImage":"inAppMessage_topImage__iNAeM","bottom_text":"inAppMessage_bottom_text__3yF0R"};